import React from "react";

function Phoenix() {
  return (
    <div className="h-12" >
   <svg width="45.923" height="253.092" viewBox="10 1000 400 120">
        <path
          fill="#63727a"
          d="M289.99.809A2.448,2.448,0,0,0,288.1,0H105.948C84.241,0,70.893,9.438,66.308,27.775l-66.2,264a2.465,2.465,0,0,0,.4,2.157,2.359,2.359,0,0,0,1.888.944H200.868c11.326,0,22.651-9.168,25.213-20.224L290.394,2.966a2.465,2.465,0,0,0-.4-2.157Z"
          data-name="Path 3817"
          transform="translate(-.013 .001)"
        />
        <path
          d="M2.137,292.192H200.605c10.247,0,20.629-8.359,22.921-18.337L287.84,2.04H105.685C88.832,2.175,73.461,7.7,68.338,28.2Z"
          data-name="Path 3818"
          transform="translate(.249 .253)"
        />
        <path
          fill="#63727a"
          d="M38.793,183.875H210.97c8.629,0,17.123-6.876,19.146-15.371L266.25,12.1H108.5c-19.281,0-27.91,6.067-31.82,22.112Zm172.177,2.157H36.1L74.523,33.675c4.989-19.685,17.123-23.6,33.977-23.6H268.947L232.138,169.044c-2.157,9.3-11.595,16.989-21.168,16.989Z"
          data-name="Path 3819"
          transform="translate(4.446 1.247)"
        />
        <path
          fill="#fff"
          d="M61.537,248.32l4.854,6.607H102.66l14.7-58.246H102.525L89.851,246.7H76.638L89.312,196.68H70.571l-1.213.944,3.775,5.124Z"
          data-name="Path 3820"
          transform="translate(7.589 24.306)"
        />
        <path
          fill="#fff"
          d="M68.178,217.069l3.506-14.022L66.83,196.44H37.167l-8.09,6.607L24.089,222.6l25.078,10.517L45.8,246.731H32.718l1.483-6.337-13.078-6.067-3.506,14.022,4.719,6.607h29.8l8.09-6.607,4.989-19.685L40.133,218.147,43.5,204.665H56.583l-1.618,6.472Z"
          data-name="Path 3821"
          transform="translate(2.162 24.276)"
        />
        <path
          fill="#fff"
          d="M159.941,203.047l-4.854-6.607H118.953l-14.7,58.246h14.831l12.539-50.022h13.213L132.3,254.686h18.606l1.213-1.079-3.64-4.989Z"
          data-name="Path 3822"
          transform="translate(12.869 24.276)"
        />
        <path
          fill="#fff"
          d="M200.3,217.069l3.506-14.022-4.854-6.607H169.287l-8.09,6.607-4.989,19.55,25.078,10.517-3.371,13.618H164.7l1.618-6.337-13.078-6.067-3.506,14.022,4.719,6.607h29.8l8.09-6.607,4.989-19.685-25.078-10.517,3.371-13.483H188.7l-1.618,6.472Z"
          data-name="Path 3823"
          transform="translate(18.489 24.276)"
        />
        <path
          fill="#bec0c2"
          d="M21.123,230.16l5.393,8.09L25.3,242.969l2.7,3.64H49.032l4.18-3.236,7.011.809-8.09,6.607h-29.8l-4.719-6.607Z"
          data-name="Path 3824"
          transform="translate(2.162 28.443)"
        />
        <path
          fill="#bec0c2"
          d="M45.085,246l7.416.809,4.18-16.584L31.332,219.578l4.18-16.449-7.146-.809-4.989,19.55,25.078,10.517Z"
          data-name="Path 3825"
          transform="translate(2.874 25.003)"
        />
        <path
          fill="#bec0c2"
          d="M59.12,200.04H38.626l-4.449,3.371,7.281.809H54.536l-1.618,6.472,7.82-2.427,1.213-4.449Z"
          data-name="Path 3826"
          transform="translate(4.208 24.721)"
        />
        <path
          fill="#bec0c2"
          d="M153.243,230.16l5.393,8.09-1.213,4.719,2.7,3.64h21.033l4.18-3.236,7.011.809-8.09,6.607h-29.8l-4.719-6.607Z"
          data-name="Path 3827"
          transform="translate(18.489 28.443)"
        />
        <path
          fill="#bec0c2"
          d="M177.2,246l7.416.809,4.18-16.584-25.348-10.652,4.18-16.449-7.146-.809L155.5,221.87l25.078,10.517Z"
          data-name="Path 3828"
          transform="translate(19.201 25.003)"
        />
        <path
          fill="#bec0c2"
          d="M191.24,200.04H170.612l-4.315,3.371,7.281.809h13.078l-1.618,6.472,7.82-2.427,1.079-4.449Z"
          data-name="Path 3829"
          transform="translate(20.535 24.721)"
        />
        <path
          fill="#bec0c2"
          d="M69.357,197.52l11.6,2.831L69.222,247l2.7,3.64H96.188l6.472,4.18H66.391l-4.854-6.607,11.6-45.572Z"
          data-name="Path 3830"
          transform="translate(7.589 24.41)"
        />
        <path
          fill="#bec0c2"
          d="M99.411,196.68l6.337,3.775L93.074,250.747,86.737,246.7Z"
          data-name="Path 3831"
          transform="translate(10.704 24.306)"
        />
        <path
          fill="#bec0c2"
          d="M125.425,200.485l-6.472-4.045-14.7,58.246h14.831l-6.472-3.91Z"
          data-name="Path 3832"
          transform="translate(12.869 24.276)"
        />
        <path
          fill="#bec0c2"
          d="M138.2,250.331l11.73-46.516-2.7-3.775H123.1l6.2,4.18h13.213l-12.539,50.022H148.58l1.213-1.079Z"
          data-name="Path 3833"
          transform="translate(15.197 24.721)"
        />
        <path
          fill="#fff"
          d="M42.234,181.611l-3.91,1.079,1.213-5.124h3.64ZM35.223,174.6l-.4.27,1.213,1.618-3.775,15.371h5.258l.27-.4-1.213-1.483.944-4.045,8.09-2.562,1.618-6.741L45.6,174.6Z"
          data-name="Path 3834"
          transform="translate(3.971 21.577)"
        />
        <path
          fill="#fff"
          d="M74.762,174.6h-3.91l-1.483,6.2-3.775.944,1.753-7.146H62.223l-.4.27,1.213,1.618-3.775,15.371h3.91l1.618-6.876,3.775-.809-1.888,7.685H71.8l.4-.4-1.213-1.483Z"
          data-name="Path 3835"
          transform="translate(7.308 21.577)"
        />
        <path
          fill="#fff"
          d="M94.407,189.027h-3.64l2.831-11.6h3.64ZM92.654,174.6l-2.562,2.022L86.857,189.7l1.618,2.157h7.011l2.562-2.157,3.236-13.078L99.665,174.6Z"
          data-name="Path 3836"
          transform="translate(10.718 21.577)"
        />
        <path
          fill="#fff"
          d="M154.4,176.622,152.78,174.6h-9.3l-4.18,17.258h3.91l3.506-14.427h3.64l-3.506,14.427h5.124l.4-.4-1.213-1.483Z"
          data-name="Path 3837"
          transform="translate(17.199 21.577)"
        />
        <path
          fill="#fff"
          d="M174.987,174.6h-5.258l-.4.27,1.348,1.618L166.9,191.858h5.123l.4-.4-1.213-1.483Z"
          data-name="Path 3838"
          transform="translate(20.609 21.577)"
        />
        <path
          fill="#fff"
          d="M200.032,190.105l-2.022-6.741,6.876-8.764H201.11l-3.91,5.258-1.348-5.258h-5.123l-.4.27,2.022,1.618,2.022,7.011-6.472,8.359h3.64l3.775-5.124,1.348,5.124h5.124l.4-.4Z"
          data-name="Path 3839"
          transform="translate(23.205 21.577)"
        />
        <path
          fill="#fff"
          d="M122.531,189.027h-4.449l1.079-4.449h3.64l.674-2.831h-3.64l1.079-4.315h4.18l1.079,1.483.4-.27.944-4.045H116.463l-.4.27,1.213,1.618L113.5,191.858h10.112l.944-4.045-.27-.27Z"
          data-name="Path 3840"
          transform="translate(14.01 21.577)"
        />
        <path
          fill="#f9a01b"
          d="M42.7,180.628l98.291-53.8-66.74,53.8,81.032-46.516-1.348,9.438L167.414,136l30.471,28.853,16.179-48.808,23.46-1.483L225.66,85.034,246.828,68.45,219.323,57.664l7.011-29.528L203.009,38.788,190.874,13.44,172.133,32.046l-33.707-15.1-4.584,30.067-30.067,6.607,17.8,10.652L103.64,73.3l15.236,1.348L56.315,123.191,119.28,89.753l-67.415,51.37,71.729-37.348L46.877,161.348l84.538-45.033Z"
          data-name="Path 3841"
          transform="translate(5.261 1.662)"
        />
        <path
          fill="#e56020"
          d="M213.533,83.13a48.918,48.918,0,1,1-46.921-50.965A48.918,48.918,0,0,1,213.533,83.13Z"
          data-name="Path 3842"
          transform="translate(14.288 3.971)"
        />
        <path
          fill="#b95915"
          d="M170.657,122.4a48.91,48.91,0,0,1-33.168-82.92,48.96,48.96,0,1,0,62.291,74.83A47.83,47.83,0,0,1,170.657,122.4Z"
          data-name="Path 3843"
          transform="translate(14.287 4.88)"
        />
        <path
          d="M213.528,81.642a32.1,32.1,0,0,0-.135-5.124,22.556,22.556,0,0,0-10.112-4.045c-.809,0-1.483-.135-2.292-.135a57.855,57.855,0,0,0-2.157-9.573,6.046,6.046,0,0,0,1.483.135c3.506.27,6.876.674,10.247,1.213a31.792,31.792,0,0,0-1.618-3.775c-3.64-.539-7.55-.944-11.46-1.213h0a57.532,57.532,0,0,0-4.449-9.168,12.843,12.843,0,0,0,6.472-3.236c-.944-.944-1.888-1.753-2.831-2.7a10.334,10.334,0,0,1-5.932,2.562c-.4-.539-.809-1.079-1.079-1.483A55.444,55.444,0,0,0,178.2,34.048a46.339,46.339,0,0,0-11.6-1.888h-.539a48,48,0,0,1,19.415,14.427,96.934,96.934,0,0,1-16.854-3.91c-1.753-.539-3.371-.944-4.989-1.483a69.309,69.309,0,0,0-23.191-2.7,49.86,49.86,0,0,0-11.46,9.034c6.2-2.562,18.606-6.876,33.707-2.7,1.618.4,3.236.809,4.989,1.348,6.607,2.022,14.157,4.18,20.629,4.18a64.253,64.253,0,0,1,4.584,8.494,36.609,36.609,0,0,0-3.775-.135c-31.55-.539-58.381,8.764-73.347,23.865a47.135,47.135,0,0,0,.944,8.764c4.18-6.067,10.517-11.6,18.606-16.18,15.1-8.494,35.325-12.944,56.763-12.674.809,0,1.483.135,2.292.135a58.583,58.583,0,0,1,2.427,9.573c-13.887.674-22.786,9.168-33.168,18.472-9.168,8.225-20.494,16.449-36.943,21.438a47.19,47.19,0,0,0,5.124,5.258c15.505-6.2,25.752-15.91,34.516-23.73,9.977-8.9,18.472-17.393,30.876-17.8a45.721,45.721,0,0,1,0,10.517c-1.618,19.146-12.809,35.46-27.91,43.55a50.029,50.029,0,0,0,11.191-2.427c1.213-1.079,2.427-2.157,3.506-3.236a59.459,59.459,0,0,0,17.393-37.483,48.092,48.092,0,0,0,0-10.786c.674.135,1.348.135,1.888.27a18.407,18.407,0,0,1,10.247,5.393Z"
          data-name="Path 3844"
          transform="translate(14.292 3.975)"
        />
      </svg>
    </div>
  );
}

export default Phoenix;